// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var GoogleIapFinishAuthController = function ($scope, $http, $routeParams, $location) {
    $scope.error = false;
    
    $http({
        method: "POST",
        url: "api/v1/externalSubscriptionSettings/FinishGoogleAuth",
        data: {
            Code: $routeParams.code,
            State: $routeParams.state,
        },
        cache: false
    }).then(function (response) {
        $location.path("/settings/external-subscriptions/GoogleIap/edit");
    }, function () {
        $scope.error = true;
    });
};
GoogleIapFinishAuthController.$inject = ['$scope', '$http', '$routeParams', '$location'];
